import { ArrowRight } from "lucide-react";
import psychImg from "@/assets/article-psychology.jpg";
import riskImg from "@/assets/article-risk.jpg";
import goldImg from "@/assets/article-gold.jpg";

const articles = [
  {
    image: psychImg,
    tag: "Psychology",
    tagColor: "bg-violet-100 text-violet-700",
    title: "Why 80% of Traders Lose After 3 Wins",
    description: "The hidden patterns sabotaging your success.",
    readTime: "5 min read",
  },
  {
    image: riskImg,
    tag: "Risk Management",
    tagColor: "bg-rose-100 text-rose-700",
    title: "Your Risk Management is Lying to You",
    description: "You think you're safe, but the numbers say otherwise.",
    readTime: "4 min read",
  },
  {
    image: goldImg,
    tag: "Market Analysis",
    tagColor: "bg-amber-100 text-amber-700",
    title: "Gold Moves Are Not Random — Here's Why",
    description: "Understanding the real logic behind market moves.",
    readTime: "6 min read",
  },
];

export const InsightsSection = () => {
  return (
    <section id="insights" className="container mx-auto px-4 sm:px-6 lg:px-8 mt-20 lg:mt-28">
      <div className="flex items-end justify-between mb-8">
        <div>
          <p className="text-[11px] font-bold tracking-widest text-emerald-700 uppercase mb-2">
            Market Insights
          </p>
          <h2 className="text-3xl lg:text-4xl font-bold tracking-tight text-foreground">
            Insights that sharpen your edge.
          </h2>
        </div>
        <a
          href="#"
          className="hidden sm:inline-flex items-center gap-1 text-sm font-semibold text-foreground/70 hover:text-foreground hover:gap-2 transition-all"
        >
          View all insights
          <ArrowRight className="h-4 w-4" />
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {articles.map((a) => (
          <article
            key={a.title}
            className="group rounded-2xl overflow-hidden bg-card shadow-card ring-1 ring-border/50 hover:shadow-elevated hover:-translate-y-1 transition-all cursor-pointer"
          >
            <div className="aspect-[16/10] overflow-hidden bg-muted">
              <img
                src={a.image}
                alt={a.title}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 space-y-3">
              <div className="flex items-center justify-between">
                <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded ${a.tagColor}`}>
                  {a.tag}
                </span>
                <span className="text-xs text-muted-foreground">{a.readTime}</span>
              </div>
              <h3 className="text-lg font-bold text-foreground leading-snug">
                {a.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {a.description}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
